import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DISTRIBUCION_POR_ESPACIO } from '../../../../../config/tables'

export class TablaDistribucionEspacioPorCerealView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DISTRIBUCION_POR_ESPACIO} />
    )
  }
}
